export default "__VITE_ASSET__9876ddf0__"